module.exports = __webpack_public_path__ + "static/img/wealth_level_88.a5a5835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_88.png
// module id = v9LB
// module chunks = 0